// extracted by mini-css-extract-plugin
module.exports = {"postItem":"style-module--postItem--3zPb0","thumbnail":"style-module--thumbnail--1-tUD"};